import List from './List'
import Detail from './Detail'

export default {
  List,
  Detail
}